<template>

    <m-edit1/>

    <m-single-post-1 v-bind='{...{"contentLink":null,"flatCategoriesShape":false},...{}}' :style='""' class="my-5 container" >
                <template #default>default   </template>
                </m-single-post-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSinglePost1 from '@moeinmdn/miw-alpha-components/src/package/Post/Single/SinglePost1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSinglePost1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
